var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('action-group',[_c('message')],1),_c('action-group',{staticClass:"hidden sm:flex"},[_c('log-in-as')],1)]},proxy:true}])},'layout',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }